import { Text } from '@mantine/core';

import classes from './index.module.css';

interface ISectionValue {
  value: string;
}

const SectionValue = ({
  value
}: ISectionValue) => {
  return <Text className={classes.value}>{value}</Text>;
}

export default SectionValue;